/**
 * @param {TreeNode} nodes - menu structure ({number} id, {string} label, {string} [screen],
 *  {IconName} [icon], {TreeNodeType} children - sub menu )
 * @returns {React.ReactNode}
 */
import React from 'react';
import { View, StyleSheet, FlatList } from 'react-native';
import { IconName } from '@fortawesome/fontawesome-common-types';
import { theme } from '../styles';
import { themeConfig } from '../styles/themeConfig';
import { BLink, BText } from '.';

interface TreeNode {
  id: number;
  label: string;
  screen?: string;
  icon?: IconName;
  children?: TreeNode[];
}

interface Props {
  nodes: TreeNode[];
  onClose: Function;
}

export const FlatlistMenu: React.FC<Props> = ({ nodes, onClose }: Props) => {
  const renderItem = (node: TreeNode, level: number) => {
    if (!node.children && node.screen) {
      return (
        <View key={node.id} style={treeViewStyle.container}>
          <BLink to={{ screen: node.screen }} onPress={onClose} style={treeViewStyle.nodeItem}>
            {node.label}
          </BLink>
        </View>
      );
    } else {
      return (
        <View key={node.id} style={treeViewStyle.container}>
          <BText style={[treeViewStyle.nodeItemHeader, level > 1 ? treeViewStyle.nodeItemHeaderL2 : null]}>
            {node.label}
          </BText>
          {node &&
            node.children &&
            node.children.map(children => {
              return renderItem(children, level + 1);
            })}
        </View>
      );
    }
  };

  return <FlatList data={nodes} renderItem={({ item }) => renderItem(item, 1)} />;
};

// Styles
const treeViewStyle = StyleSheet.create({
  nestedContainer: {
    marginLeft: 10,
  },
  container: {
    marginLeft: 0,
  },
  nodeItemHeader: {
    flex: 1,
    flexDirection: 'column',
    paddingHorizontal: 12,
    paddingVertical: 8,
    borderBottomColor: themeConfig.colors.borderLightGrey,
    borderBottomWidth: 1,
    color: themeConfig.colors.grey,
    fontWeight: 'bold',
  },
  nodeItemHeaderL2: {
    fontWeight: 'normal',
    fontStyle: 'italic',
  },
  nodeItem: {
    flex: 1,
    //flexDirection: 'row',
    paddingHorizontal: 12,
    paddingVertical: 8,
    borderBottomColor: themeConfig.colors.borderLightGrey,
    borderBottomWidth: 1,
  },
  nodeItemIcon: {
    width: 20,
  },
  nodeItemText: {
    ...theme.text.menu,
  },
});
